export default "__VITE_ASSET__UUDriP9V__"